import { Button, Modal } from "@xola/ui-kit";
import React from "react";
import { CheckInVerificationStatus, ExperiencePurchaseItem } from "types";

interface MemberVerificationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onContinue: (verificationStatus: CheckInVerificationStatus) => void;
    purchaseItem?: ExperiencePurchaseItem;
}

type VerificationOptionValue = CheckInVerificationStatus | "cancel";

interface VerificationOption {
    value: VerificationOptionValue;
    label: string;
}

const options: VerificationOption[] = [
    {
        value: CheckInVerificationStatus.ID_VERIFIED,
        label: "Identity Verified",
    },
    {
        value: CheckInVerificationStatus.NOT_VERIFIED,
        label: "Unable to verify identity but check in anyway",
    },
    {
        value: "cancel",
        label: "Unable to verify identity & do not check-in",
    },
];

export const MemberVerificationModal = ({
    onClose,
    isOpen,
    onContinue,
    purchaseItem,
}: MemberVerificationModalProps) => {
    if (!purchaseItem?.membershipPurchaseItem || !("organizer" in purchaseItem.membershipPurchaseItem)) {
        return null;
    }

    const handleSelect = (option: VerificationOptionValue) => {
        if (option === "cancel") {
            onClose();
            return;
        }

        onContinue(option);
    };

    return (
        <Modal isOpen={isOpen} size="medium" onClose={onClose}>
            <Modal.Header description="Member ID must be verified by you to proceed with check-in.">
                Verify Member ID
            </Modal.Header>
            <Modal.Body>
                <span>
                    Member Name: <strong>{purchaseItem.membershipPurchaseItem.organizer.name}</strong>
                </span>

                <div className="mt-2 flex flex-col gap-2">
                    {options.map((option) => (
                        <Button
                            key={option.value}
                            variant="outline"
                            color="secondary"
                            onClick={() => handleSelect(option.value)}
                        >
                            {option.label}
                        </Button>
                    ))}
                </div>
            </Modal.Body>
        </Modal>
    );
};
